import { h, Fragment } from 'preact'
import ErrorMessage from './ErrorMessage'
import Masonry from 'react-masonry-css'
import Project from './Project'
import CTA from './Cta'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const breakpointColumnsObj = {
  default: 3,
  900: 2,
  500: 1
};

const Projects = (props) => {
  if (props.error) {
    return <ErrorMessage type="posts-error" />
  }

  if (!props.loading && props.projects.length === 0) {
    return <ErrorMessage type="no-results" />
  }

  if(props.projects.length){
    return (

      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="c-masonry-grid"
        columnClassName="c-masonry-grid__column">
        {
        props.projects.map((project, index) => {
            return (
              <Fragment>
                <Project project={project} key={project.id} language={props.language} />

                {index % 3 === 1 && index < 3 ? (
                  <CTA 
                    ctaTitle={props.ctaTitle} 
                    ctaSubtitle={props.ctaSubtitle} 
                    ctaContent={props.ctaContent} 
                    ctaButtonUrl={props.ctaButtonUrl} 
                    ctaButtonContent={props.ctaButtonContent} 
                  />
                ) : null}
              </Fragment>
            )
          })
        }
      </Masonry>
    )
  }
}
export default Projects


// WEBPACK FOOTER //
// ./src/js/app/components/Projects.js